export const users = {
    get: () => axios.get('/chain/api/users').then((res) => res.data),
    getUser: (id) => axios.get(`/chain/api/users/${id}/get`).then((res) => res.data),
    createUser: (data) => axios.post(`/chain/api/users/create`, data).then((res) => res.data),
    updateUser: (id, data) => axios.put(`/chain/api/users/${id}/update`, data).then((res) => res.data),
    settings: () => axios.get(`/chain/api/users/user-settings`).then((res) => res.data),
    deleteUser: (id) => axios.delete(`/chain/api/users/${id}/delete`).then((res) => res.data),
};
